<div class="fb-input-wrapper" [formGroup]="formGroup" #divElement>
  <label class="form-field-name" *ngIf="isTitle" [for]="id">{{label | translate}}</label>
  <mat-form-field appearance="outline">
    <mat-select
      [formControlName]="name"
      [placeholder]="placeholder ? (placeholder | translate) : ''"
      [id]="id"
      (selectionChange)="emitChanges($event)"
      [value]="formControl.value"
    >
      <mat-option *ngIf="isSearchOption">
        <ngx-mat-select-search
          [formControl]="filterControl"
          placeholderLabel="{{'Search' | translate}}"
          noEntriesFoundLabel="{{'Option not found' | translate}}"
        ></ngx-mat-select-search>
      </mat-option>

      <mat-option *ngFor="let option of options$ | async" [value]="option.value">
        {{option.label | translate}}
      </mat-option>

    </mat-select>
  </mat-form-field>
  <span class="bottom-label error-message" *ngIf="formControl.touched && formControl.invalid && !customError; else labelTemplate">{{getErrorMessage()}}</span>
</div>

<ng-template #labelTemplate>
  <span class="bottom-label" *ngIf="!isTitle" [ngStyle]="labelStyle">{{label | translate}}</span>
</ng-template>
